// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__e2Bmf","modalFooterButton":"ModalNotes_modalFooterButton__1NPSG"};